import store from '@/state/store'

export default [{
    path: '/', meta: {
        authRequired: true
    }, name: 'home', component: () => import('./views/home'),
},

{
    path: '/login', name: 'login', component: () => import('./views/account/login/login'), meta: {
        title: "Login", beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
                // Redirect to the home page instead
                next({
                    name: 'home'
                })
            } else {
                // Continue to the login page
                next()
            }
        },
    },
}, {
    path: '/register', name: 'register', component: () => import('./views/account/register'), meta: {
        title: "Register", beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
                // Redirect to the home page instead
                next({
                    name: 'home'
                })
            } else {
                // Continue to the login page
                next()
            }
        },
    },
},
// ========================
//       PURCHASING
// ========================
{
    path: '/purchase-order',
    name: 'Purchase Order',
    meta: { title: "Purchase Order", authRequired: true },
    component: () => import('./views/purchase-order/list/list-po.vue'),
},

{
    path: '/purchase-order/create',
    name: 'Create Purchase Order',
    meta: { title: "Create PO", authRequired: true },
    component: () => import('./views/purchase-order/create/create-po.vue'),
},
{
    path: "/purchase-order/edit/:id",
    name: 'Edit Purchase Order',
    meta: { title: "Edit PO", authRequired: true },
    component: () => import("./views/purchase-order/edit/edit-po.vue")
},
// ========================
//       PAYMENT
// ========================
{
    path: '/payment-method/list',
    name: 'Payment Method List',
    meta: { title: "Payment Method List", authRequired: true },
    component: () => import('./views/payment/list/list-payment.vue'),
},

{
    path: '/payment-method/create',
    name: 'Create Payment Method',
    meta: { title: "Create Payment Method", authRequired: true },
    component: () => import('./views/payment/create/create-payment.vue'),
},
// ========================
//       office
// ========================
{
    path: '/master/office/list',
    name: 'Office List',
    meta: { title: "Office List", authRequired: true },
    component: () => import('./views/master/office/list/list-office.vue'),
},

{
    path: '/master/office/create',
    name: 'Create Office',
    meta: { title: "Create Office", authRequired: true },
    component: () => import('./views/master/office/create/create-office.vue'),
},

// ========================
//       information
// ========================
{
    path: '/master/information/list',
    name: 'Information List',
    meta: { title: "Information List", authRequired: true },
    component: () => import('./views/master/information/list-information.vue'),
},

{
    path: '/master/complaint/list',
    name: 'Complaint List',
    meta: { title: "Complaint List", authRequired: true },
    component: () => import('./views/master/complaint/list-complaint.vue'),
},

// ========================
//       Invoice
// ========================
{
    path: '/finance/invoice/list',
    name: 'Invoice List',
    meta: {
        title: "Invoice List",
        authRequired: true
    },
    component: () =>
        import('./views/finance/invoice/list/list-invoice.vue'),
},

{
    path: '/finance/invoice/detail/:id',
    name: 'Invoice Detail',
    meta: {
        title: "Invoice Detail",
        authRequired: true
    },
    component: () =>
        import('./views/finance/invoice/detail/detail-invoice.vue'),
},

{
    path: "/finance/invoice/:id/print/:type",
    name: "Print Invoice",
    component: () => import(
        "./views/finance/invoice/print/print-invoice.vue"
    )
},

// ========================
//        INVENTORY
// ========================
{
    path: '/inventory',
    name: 'Inventory',
    meta: { title: "Inventory", authRequired: true },
    component: () => import('./views/inventory/dashboard.vue'),
}, {
    path: '/inventory/mst-stock',
    name: 'Master Stock',
    meta: { title: "Master Stock", authRequired: true },
    component: () => import('./views/inventory/stock/master/mst-stock.vue'),
}, {
    path: '/inventory/trn-stock',
    name: 'Transaction Stock',
    meta: { title: "Transaction Stock", authRequired: true },
    component: () => import('./views/inventory/stock/transaction/trn-stock.vue'),
},
// ========================
//        Customer
// ========================
{
    path: '/master/customer/list',
    name: 'list-Customer',
    meta: { title: "List customer", authRequired: true },
    component: () => import('./views/master/customer/list/customerList.vue'),
},

{
    path: '/master/customer/create',
    name: 'create-Customer',
    meta: { title: "Create customer", authRequired: true },
    component: () => import('./views/master/customer/create/createCustomer.vue'),
},

{
    path: '/master/customer/:id',
    name: 'detail-Customer',
    meta: { title: "Customer Detail", authRequired: true },
    component: () => import('./views/master/customer/detail/customerDetail.vue'),
},


// ========================
//        WORK ORDER
// ========================
{
    path: '/work-order',
    name: 'Work Order',
    meta: { title: "Work Order", authRequired: true },
    component: () => import('./views/workorder/list/list-wo.vue'),
}, {
    path: '/work-order/:id',
    name: 'Work Order Detail',
    meta: { title: "Work Order Detail", authRequired: true },
    component: () => import('./views/workorder/detail/detail-wo.vue'),
},
{
    path: "/work-order/material-history/:id", name: "WorkOrderMaterialHistory",
    meta: { title: "Material History", authRequired: true },
    component: () => import('./views/workorder/trnStock/history-wo.vue'),
},
// ========================
//        Supplier
// ========================
{
    path: '/master/supplier',
    name: 'Supplier List',
    meta: { title: "Supplier", authRequired: true },
    component: () => import('./views/master/supplier/list/list-supplier.vue'),
},
{
    path: '/supplier/:id',
    name: 'SupplierDetail',
    component: () => import('./views/master/supplier/detail/detail-supplier.vue'),
},
{
    path: '/master/supplier/create',
    name: 'Create Supplier',
    meta: { title: "Create Supplier", authRequired: true },
    component: () => import('./views/master/supplier/create/create-supplier.vue'),
},
{
    path: '/master/supplier/business-type',
    name: 'List Business Type',
    meta: { title: "List Business Type", authRequired: true },
    component: () => import('./views/master/businessType/list/list-business-type.vue'),
},
{
    path: '/master/supplier/business-type/create',
    name: 'Create Business Type',
    meta: { title: "Create Business Type", authRequired: true },
    component: () => import('./views/master/businessType/create/create-business-type.vue'),
}
    ,
// ========================
//       ITEM
// ========================
{
    path: '/master/item/create',
    name: 'Create Master Item',
    meta: { title: "List Master Item", authRequired: true },
    component: () => import('./views/item/master/create/create-item.vue'),
},
{
    path: '/master/item/list',
    name: 'List Master Item  ',
    meta: { title: "List Master Item", authRequired: true },
    component: () => import('./views/item/master/list/list-item.vue'),
},
{
    path: '/inventory/items/detail/:id',
    name: 'ItemDetail',
    component: () => import('./views/item/master/detail/item-detail.vue')
},

{
    path: '/inventory/items/:itemId/selling-price/create',
    name: 'CreateSellingPrice',
    component: () => import('./views/item/price/create-selling-price.vue')
},
{
    path: '/inventory/items/vendor',
    name: 'Vendor',
    component: () => import('./views/item/vendor/list-vendor.vue')
},

//unit
{
    path: '/master/unit/list',
    name: 'List Unit',
    meta: { title: "List Unit", authRequired: true },
    component: () => import('./views/item/unit/list/listUnit.vue'),
},
{
    path: '/master/unit/create',
    name: 'Create Unit',
    meta: { title: "Create Unit", authRequired: true },
    component: () => import('./views/item/unit/create/create-unit.vue'),
},
{
    path: '/item/categories/create',
    name: 'Create Categories Item ',
    meta: { title: "Create Categories Item", authRequired: true },
    component: () => import('./views/item/categories/create/createCategory.vue'),
},
{
    path: '/item/categories/list',
    name: 'List Categories Item',
    meta: { title: "List Categories Item ", authRequired: true },
    component: () => import('./views/item/categories/list/listCategory.vue'),
},


// ========================
//       ITEM Genset
// ========================
{
    path: '/genset/master/item/create',
    name: 'Create Master Item Genset',
    meta: { title: "List Master Item Genset", authRequired: true },
    component: () => import('./views/item/master/create/create-item.vue'),
},
{
    path: '/genset/master/item/list',
    name: 'List Master Item Genset ',
    meta: { title: "List Master Item Genset", authRequired: true },
    component: () => import('./views/item/master/list/list-item.vue'),
},

//unit
{
    path: '/genset/master/unit/list',
    name: 'List Unit Genset',
    meta: { title: "List Unit Genset", authRequired: true },
    component: () => import('./views/item/unit/list/listUnit.vue'),
},
{
    path: '/genset/master/unit/create',
    name: 'Create Unit Genset',
    meta: { title: "Create Unit Genset", authRequired: true },
    component: () => import('./views/item/unit/create/create-unit.vue'),
},
{
    path: '/genset/item/categories/create',
    name: 'Create Categories Item Genset',
    meta: { title: "Create Categories Item Genset", authRequired: true },
    component: () => import('./views/item/categories/create/createCategory.vue'),
},
{
    path: '/genset/item/categories/list',
    name: 'List Categories Item Genset',
    meta: { title: "List Categories Item Genset", authRequired: true },
    component: () => import('./views/item/categories/list/listCategory.vue'),
},
//item unit
{
    path: '/item/itemUnit/create',
    name: 'Create Item Unit Genset',
    meta: { title: "Create Item Unit Genset", authRequired: true },
    component: () => import('./views/item/itemUnit/create/createItemUnit.vue'),
},
{
    path: "/service/master/detail/:id",
    name: "ServiceDetail",
    meta: { title: "Service Detail", authRequired: true },
    component: () => import("./views/Service/Master/detail/serviceDetail.vue")
},

// ========================
//       Job  Card
// ========================
{
    path: '/job-card',
    name: 'Job Card',
    meta: { title: "Job Card", authRequired: true },
    component: () => import('./views/Service/JobCard/Service/list/list-job-card.vue'),
},
{
    path: '/job-card/create',
    name: 'Create Job Card',
    meta: { title: "Create Job Card", authRequired: true },
    component: () => import('./views/Service/JobCard/Service/create/create-job-card.vue'),
},
{
    path: '/job-card/search',
    name: 'search Job Card',
    meta: { title: "search Job Card", authRequired: true },
    component: () => import('./views/Service/JobCard/Service/search/search-job-card.vue'),
},
{
    path: '/job-card/status',
    name: 'Status Job Card',
    meta: { title: "Status Job Card", authRequired: true },
    component: () => import('./views/Service/JobCard/Service/status/jobcardStatus.vue'),
},
{
    path: '/job-card/print/:id/:type',
    name: 'Print Job Card',
    meta: { title: "Print Quotation", authRequired: true },
    component: () => import('./views/Service/JobCard/Service/print/print-job-card.vue'),
},

// ========================
//       EDIT JOB CARD
// ========================
{
    path: '/job-card/edit/:id',
    name: 'Edit Job Card',
    meta: { title: "Edit Job Card", authRequired: true },
    component: () => import('./views/Service/JobCard/Service/edit/edit-job-card.vue'),
},


{
    path: '/job-card/category',
    name: 'Job Card Category',
    meta: { title: "Job Card Category", authRequired: true },
    component: () => import('./views/Service/JobCard/Category/indexCategory.vue'),
},
// ========================
//       Service
// ========================
//master
{
    path: '/service/list',
    name: 'List Service',
    meta: { title: "List Service", authRequired: true },
    component: () => import('./views/Service/Master/list/listService.vue'),
}, {
    path: '/service/create',
    name: 'Create Service',
    meta: { title: "Create Service", authRequired: true },
    component: () => import('./views/Service/Master/create/createService.vue'),
},
//Category
{
    path: '/service/category/list',
    name: 'List Service Category',
    meta: { title: "List Service Category", authRequired: true },
    component: () => import('./views/Service/Category/list/listServiceCategory.vue'),
}, {
    path: '/service/category/create',
    name: 'Create Service Category',
    meta: { title: "Create Service Category", authRequired: true },
    component: () => import('./views/Service/Category/create/createServiceCategory.vue'),
},

// ========================
//            HR
// ========================
{
    path: '/hr',
    name: 'HR',
    meta: { title: "Human Resource", authRequired: true },
    component: () => import('./views/hr/dashboard.vue'),
},

// =========================
// EMPLOYEE ROUTES
// =========================
{
    path: '/hr/employee',
    name: 'Employee List',
    meta: { title: "Employees", authRequired: true },
    component: () => import('./views/hr/employee/list/employees-list.vue'),
},
{
    path: '/hr/employee/create',
    name: 'Create Employee',
    meta: { title: "Create Employee", authRequired: true },
    component: () => import('./views/hr/employee/create/employees-create.vue'),
},
// ========================
//       Position
// ========================
{
    path: '/master/position/list',
    name: 'Position List',
    meta: { title: "Position List", authRequired: true },
    component: () => import('./views/master/position/list/list-position.vue'),
},

{
    path: '/master/position/create',
    name: 'Create Position',
    meta: { title: "Create Position", authRequired: true },
    component: () => import('./views/master/position/create/create-position.vue'),
},

// =========================
// MASTER SALARY
// =========================
{
    path: '/hr/salary/master',
    name: 'Master Salary',
    meta: { title: "Master Salary", authRequired: true },
    component: () => import('./views/hr/salary/mst/list/mst-salary.vue'),
}, {
    path: '/hr/salary/master/create',
    name: 'Create Master Salary',
    meta: { title: "Create Master Salary", authRequired: true },
    component: () => import('./views/hr/salary/mst/create/mst-salary.vue'),
},

// =========================
// TRANSACTION SALARY
// =========================
{
    path: '/hr/salary/transaction',
    name: 'Salary Transactions',
    meta: { title: "Payroll Transactions", authRequired: true },
    component: () => import('./views/hr/salary/trn/trn-salary.vue'),
},

// =========================
// ATTENDANCE
// =========================
{
    path: '/hr/attendance',
    name: 'Attendance',
    meta: { title: "Attendance", authRequired: true },
    component: () => import('./views/hr/attendance/list/attendance-list.vue'),
},

// =========================
// SCHEDULE
// =========================
{
    path: '/hr/schedule',
    name: 'list Schedule',
    meta: { title: "list Schedule", authRequired: true },
    component: () => import('./views/hr/schedule/list/list-schedule.vue'),
}, {
    path: '/hr/schedule/create',
    name: 'Create Schedule',
    meta: { title: "Create Schedule", authRequired: true },
    component: () => import('./views/hr/schedule/create/create-schedule.vue'),
},


// ========================
//         REPORTS
// ========================
{
    path: "/work-order/report",
    name: "work-order-report",
    component: () =>
        import(
            "./views/reports/workOrder/list/list-work-order-report.vue"
        )
},

{
    path: "/work-order/report/:id",
    name: "work-order-report-detail",
    component: () =>
        import(
            "./views/reports/workOrder/detail/detail-work-order-report.vue"
        )
},
{
    path: "/employee-monthly-report",

    name: "employee-monthly-report",

    component: () =>
        import(
           "./views/reports/workOrder/employee/list/list-employee-monthly-report.vue"
        )
},

{
    path: "/employee-monthly-report/:employeeId",

    name: "employee-monthly-report-detail",

    component: () =>
        import(
              "./views/reports/workOrder/employee/detail/detail-employee-monthly-report.vue"
        )
},
{
    path: '/reports',
    name: 'Reports',
    meta: { title: "Reports", authRequired: true },
    component: () => import('./views/reports/reports.vue'),
}, {
    path: '/reports/sales',
    name: 'Sales Report',
    meta: { title: "Sales Report", authRequired: true },
    component: () => import('./views/reports/sales.vue'),
}, {
    path: '/reports/inventory',
    name: 'Inventory Report',
    meta: { title: "Inventory Report", authRequired: true },
    component: () => import('./views/reports/inventory.vue'),
}, {
    path: '/reports/monthly',
    name: 'Monthly Report',
    meta: { title: "Monthly Report", authRequired: true },
    component: () => import('./views/reports/monthly.vue'),
},

{
    path: '/logout', name: 'logout', meta: {
        title: "Logout", authRequired: true, beforeResolve(routeTo, routeFrom, next) {
            if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                store.dispatch('auth/logOut')
            } else {
                store.dispatch('authfack/logout')
            }
            const authRequiredOnPreviousRoute = routeFrom.matched.some((route) => route.push('/login'))
            // Navigate back to previous page, or home as a fallback
            next(authRequiredOnPreviousRoute ? {
                name: 'default'
            } : {
                ...routeFrom
            })
        },
    },
},

]